/** @format */

import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Card,
  CardHeader,
  CardBody,
  CardText,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Button,
} from "reactstrap";

import Loader from "../components/Loader";
import jquery from "jquery";
import "react-notifications-component/dist/theme.css";
import "react-notifications/lib/notifications.css";
import "animate.css/animate.min.css";
import "animate.css/animate.compat.css";
import "animate.css";
import { store } from "react-notifications-component";
import { login } from "../global/url";
import { showNotification } from "../global/notification";
import { withRouter } from "react-router-dom";
import { XORCipher } from "./../global/XORCipher"
import {
  setCookie,
  getCookie,
  eraseCookie,
  setLocalStorage,
  getLocalStorage,
  getUrlParam
} from "../global/browserFunctions";

class Reset extends Component {
  constructor(props) {
    super(props);
    //  console.log('props',props)
    var loggedin = getCookie("log");
    if (loggedin) this.GoToPage("/"); // Check whether customer is logged in, if yes redirect to home
    this.state = {
      password: "",
      loading: false,
      cpassword: "",
      passwordHidden: true,
      cpasswordHidden: true,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleShow = this.toggleShow.bind(this);
    document.title = "Reset Password";
  }
  handleChange(event) {
    var target = event.target;
    var name = target.name;
    var value = target.value;
    this.setState({ [name]: value });
  }

  toggleShow(field) { //Hide/Show password field
    if (field == "password")
      this.setState({ passwordHidden: !this.state.passwordHidden });
    else
      this.setState({ cpasswordHidden: !this.state.cpasswordHidden });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ loading: true });
    var self = this;
    var password = this.state.password;
    var cpassword = this.state.cpassword;
    if (password !== cpassword) {
      this.state.password = null;
      this.setState({ loading: false });
      showNotification("Information!", "warning", "Passwords not matching");
      return false;
    }
    var email = getUrlParam("email");
    var tstamp = getUrlParam("tstamp");
    var latest_time = new Date().getTime();
    var resolution = latest_time - tstamp;
    var resolutionTime = resolution / 1000 / 60;
    var tstamp = Date.parse(new Date()).toString()
    var encrypt = XORCipher.encode(tstamp, this.state.password)
    if (resolutionTime < 10) {
      var query = "&email=" + encodeURIComponent(email) + "&newpassword=" + encodeURIComponent(encrypt) + "&timeStamp=" + encodeURIComponent(tstamp) + "&status=resetpassword";
      //  console.log("&email="+email+"&newpassword="+this.state.password)
      jquery.ajax({
        url: login + query,
        dataType: 'jsonp',
      })
        .done(function (data) {
          //  console.log(data)
          data = JSON.parse(data);
          data = data[0];
          if (data.responseString === "SUCCESS") {
            self.setState({ loading: false });
            setTimeout( //Timeout is set for user to read success message before redirecting to login page
              function () {
                self.GoToPage("/");
              }
                .bind(this),
              1800
            );

            showNotification("Done!", "success", "Password Reset Successful");

          }
          else {
            self.setState({ loading: false });
            showNotification("Error", "danger", "An unknown error occured! Please try again later.");
          }
        })
    }
    else {
      self.setState({ loading: false });
      showNotification("Error", "danger", "Invalid Reset Password Link!");
    }
  }
  GoToPage(path) {
    this.props.history.push(path);
  }
  render() {
    return (
      <React.Fragment>
        <section className="pb-5">
          <Container>
            <Row className="abc">
              <Col lg="8">
                <Loader loading={this.state.loading} />
                <Card>
                  <CardHeader className="py-4 px-5">
                    <h5 className="mb-0">Reset Password</h5>
                  </CardHeader>
                  <CardBody className="p-5">
                    <Form onSubmit={this.handleSubmit}>
                      <FormGroup>
                        <Label className="form-label" for="passwordSignup">
                          Password
                        </Label>
                        <Input
                          name="password"
                          type={this.state.passwordHidden ? 'password' : 'text'}
                          pattern=".{8,}"
                          required
                          title="8 characters minimum"
                          onChange={this.handleChange}
                          value={this.state.password}
                        />
                        <span
                          className="fa fa-fw fa-eye field-icon-password"
                          onClick={(event) => this.toggleShow('password')}
                        ></span>
                      </FormGroup>
                      <FormGroup>
                        <Label className="form-label" for="passwordSignup">
                          Confirm Password
                        </Label>
                        <Input
                          name="cpassword"
                          type={this.state.cpasswordHidden ? 'password' : 'text'}
                          pattern=".{8,}"
                          required
                          title="8 characters minimum"
                          onChange={this.handleChange}
                          value={this.state.cpassword}
                        />
                        <span
                          className="fa fa-fw fa-eye field-icon-password"
                          onClick={this.toggleShow}
                        ></span>
                      </FormGroup>

                      <Button color="dark" type="submit">
                        <i className="fa fa-sign-in-alt mr-2" /> Submit
                      </Button>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}
export default Reset;
